import { Box } from '@mui/material'
import ListMaterial, { ListProps } from '@mui/material/List'
import { omit } from 'ramda'
import {
  Children,
  cloneElement,
  isValidElement,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from 'react'
import { connectField, FieldProps, filterDOMProps } from 'uniforms'
import { BooleanRadioInput } from './BooleanRadioField'
import ListAddField from './ListAddField'
import ListItemField from './ListItemField'

export type ListFieldProps = FieldProps<
  unknown[],
  ListProps,
  { addIcon?: ReactNode; itemProps?: object }
>

function List({
  addIcon,
  children = <ListItemField name="$" />,
  itemProps,
  label,
  value,
  ...props
}: ListFieldProps & { 'ui-params'?: any }) {
  const uiParams = props?.['ui-params'] || {}

  const [itemsExist, setItemsExist] = useState<boolean | undefined>(
    value ? !!value?.length : undefined
  )

  useEffect(() => {
    setItemsExist(!!value?.length)
  }, [value?.length])

  const filteredProps = omit(['addItemCta', 'removeItemCta'], filterDOMProps(props))

  return (
    <Box justifyItems={'right'}>
      {!!uiParams.itemsExistCta && (
        <>
          {/** @ts-ignore This provides sufficient props for the "input" needs. */}
          <BooleanRadioInput
            data-testid={`item-exists-input-${props.name}`}
            required
            label={uiParams.itemsExistCta}
            onChange={(value: boolean | unknown) => {
              if (typeof value === 'boolean') {
                props.onChange(value ? [{}] : [])
                setItemsExist(value)
              } else {
                setItemsExist(undefined)
              }
            }}
            value={itemsExist}
          />
        </>
      )}

      <ListMaterial dense {...filteredProps}>
        {value?.map((_, itemIndex) =>
          Children.map(children, (child, childIndex) =>
            isValidElement(child)
              ? cloneElement(child as ReactElement, {
                  key: `${itemIndex}-${childIndex}`,
                  name: child.props.name?.replace('$', '' + itemIndex),
                  removeItemCta: uiParams.removeItemCta,
                  ...itemProps,
                })
              : child
          )
        )}
      </ListMaterial>

      <Box sx={{ mr: 2 }}>
        <ListAddField icon={addIcon} name="$" cta={uiParams.addItemCta} />
      </Box>
    </Box>
  )
}

export default connectField<ListFieldProps>(List)
